module.exports = __webpack_public_path__ + "static/img/bg-11.83cea5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-11.png
// module id = glnW
// module chunks = 0